<template>
  <div class="not-found-root" :style="{ paddingTop: barHeight + 'px', ...cssVars() }">
    <div class="main">
      <img class="empty-img" src="@/assets/packageAssets/common/null_bg.webp" alt="" />
      <p class="code">404</p>
    </div>
  </div>
</template>

<script>
import { getBaseFeature } from '@/assets/style/variable'

export default {
  name: 'NotFound',
  methods: {
    cssVars() {
      return { ...getBaseFeature() }
    },
    goHome() {
      this.$router.replace({ name: 'home' })
    },
  },
}
</script>

<style lang="scss" scoped>
.not-found-root {
  width: 100%;
  min-height: 100vh;
  background: #ffffff;

  .main {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 12vh 24px 0;

    .empty-img {
      width: 200px;
      margin-bottom: 16px;
    }

    .code {
      margin: 0 0 8px;
      font-family: var(--number-font);
      font-size: 48px;
      font-weight: var(--fw-900);
      line-height: 1;
      color: #cccccc;
    }

    .desc {
      width: 80%;
      margin: 0 0 32px;
      text-align: center;
      color: #666666;
      font-family: var(--number-font);
      font-size: var(--fs-16);
      line-height: var(--lh-title-24);
    }
  }
}
</style>
